import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DisqusComments from "../../DisqusComments";
import "../../../../css/components/article.css";

function ArticleDetail() {
    const { encryptedId } = useParams();
    const [article, setArticle] = useState(null);

    useEffect(() => {
        const fetchArticle = async () => {
            const response = await window.apiClient.get(`/data/get/article/${encryptedId}`);
            setArticle(response.data);
        };
        fetchArticle();
    }, [encryptedId]);

    if (!article) return <div>Loading...</div>;
    return (
        <>
            <div className="col-span-12 py-5 text-center">
                <h4 className="text-lg font-bold text-gray-800 uppercase">{article.judul_artikel}</h4>
            </div>
            <div className="row">
                <div className="col-span-12 md:col-span-12 sm:col-span-12">
                    <h3 className="text-base text-gray-600" dangerouslySetInnerHTML={{
                        __html: article.konten_artikel
                    }}></h3>
                </div>
            </div>
            <div className="flex justify-end items-center mt-4">
                <span className="flex items-center text-sm text-gray-500">
                    <i className="mr-2 fa fa-spinner" aria-hidden="true"></i>
                    Post by: Osis
                </span>
            </div>
            <div className="flex justify-end items-center mt-2 space-x-4">
                <span className="flex items-center text-sm text-gray-500">
                    <i className="mr-2 fa fa-calendar" aria-hidden="true"></i>
                    {article.update_date.substring(0, 10)}
                </span>
            </div>
            <DisqusComments pageIdentifier={article.id_artikel} pageUrl={`https://osis.sman2amlapura.sch.id/article/${article.id_artikel}`} />
        </>
    );
}

export default ArticleDetail;
